import { render, staticRenderFns } from "./ModalHeaderV2.vue?vue&type=template&id=d965bff8&"
import script from "./ModalHeaderV2.vue?vue&type=script&lang=js&"
export * from "./ModalHeaderV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports